import {Box} from '@mui/material';
import Image from 'mui-image';

import wifidIcon from './wifid.svg'

interface Props {
  color?: 'red' | 'white';
  size?: number;
}


export const WifiDIcon = ({ color = 'red', size = 20 }: Props) => {
    return (
      <Box
        sx={{
          '& img': {transition: 'none !important', animation: 'none !important'},
          transition: 'none !important',
          color: color
        }}
      >
        <Image
          src={wifidIcon}
          alt="wi-fi-c"
          width={size}
          height={size}
        />
      </Box>
    );
};

export default WifiDIcon;
